import { forwardRef } from 'react';
import { PatternFormat } from 'react-number-format';
import moment from 'moment';

export const DateField = forwardRef((props, ref) => {
    const { input, meta, label, required = false, placeholder, ariaLabelledBy, ...patternProps } = props;
    const inputId = `date-${input.name}`;
    const errorId = `error-${input.name}`;
    const formatId = `format-${input.name}`;

    let inputValue = '';

    if (moment.isMoment(input.value)) {
        inputValue = input.value.format('DD/MM/YYYY');
    } else if (input.value) {
        const parsed = moment(input.value, 'DD/MM/YYYY');
        if (parsed.isValid()) {
            inputValue = parsed.format('DD/MM/YYYY');
        } else {
            inputValue = input.value;
        }
    }

    const handleValueChange = (values) => {
        if (!input?.onChange) return;

        if (values.value.length === 8) {
            const dateMoment = moment(values.formattedValue, 'DD/MM/YYYY', true);

            if (dateMoment.isValid()) {
                return input.onChange(dateMoment);
            } else {
                return input.onChange(null);
            }
        }

        return input.onChange(null);
    };

    const hasError = meta?.error;

    return (
        <div className="form-group">
            {label && (
                <label htmlFor={inputId} className="label-text mb-1">
                    {label}
                    {required && <><sup className="text-danger" aria-hidden="true">*</sup><span className="visually-hidden"> (obligatoire)</span></>}
                </label>
            )}
            <PatternFormat
                {...patternProps}
                id={inputId}
                format="##/##/####"
                mask="_"
                placeholder={placeholder || 'JJ/MM/AAAA'}
                value={inputValue}
                onValueChange={handleValueChange}
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                style={{ height: 50, border: '1px solid #949596' }}
                getInputRef={ref}
                aria-required={required ? 'true' : undefined}
                aria-invalid={hasError ? 'true' : undefined}
                aria-describedby={hasError ? `${formatId} ${errorId}` : formatId}
                aria-labelledby={!label && ariaLabelledBy ? ariaLabelledBy : undefined}
                aria-label={!label && !ariaLabelledBy ? (placeholder || 'Date au format JJ/MM/AAAA') : undefined}
            />
            <small id={formatId} className="visually-hidden">
                {placeholder ? placeholder : 'Format attendu : JJ/MM/AAAA'}
            </small>

            {hasError && <small id={errorId} className="alert alert-danger invalid-feedback d-block" role="alert">{meta.error}</small>}
        </div>
    );
});
